<template>
  <el-row>
    <el-col :span="8">
      <span>{{ $t('orderList.selectDateRange') }}</span>
      <div class="title">
        <date-range-picker
          @update="onDatechange"
          v-model="picker"
          opens="right"
          ref="picker"
          auto-apply
        >
        </date-range-picker>
      </div>
    </el-col>
    <el-col :span="5">
      <span id="location">{{ $t('orderList.location') }}</span>
      <slot />
    </el-col>

    <el-col :span="2">
      <div class="buttons-container">
        <div class="button-wrapper">
          <el-upload
            :limit="1"
            :http-request="loadFile"
            :on-exceed="handleExceed"
            :accept="'.csv'"
            action=""
          >
            <el-button class="upload-button">
              {{ $t('orderList.uploadBambooIds') }}
            </el-button>
            <div class="hint-message">
              {{ $t('orderList.uploadHint') }}
            </div>
          </el-upload>
        </div>
      </div>
    </el-col>

    <el-col :span="2">
      <div v-if="isDataToExport" class="buttons-container">
        <div class="button-wrapper">
          <download-csv :data="this.export" :name="this.reportName">
            <el-button class="button">{{ $t('orderList.export') }}</el-button>
            <span class="hint-message">{{ $t('orderList.exportHint') }}</span>
          </download-csv>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import OfficeDropdown from '@/components/OfficeDropdown';
import WeekNavigator from '@/components/WeekNavigator';
import { getWeekStartAndEndDate } from '@/helpers';
import csvtojson from 'csvtojson';
import { mapState } from 'vuex';

import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    WeekNavigator,
    OfficeDropdown,
    DateRangePicker,
  },
  data() {
    return {
      picker: {
        startDate: null,
        endDate: null,
      },
    };
  },
  props: {
    export: {
      type: Array,
      required: false,
      default: () => [],
    },
    reportName: {
      type: String,
      required: false,
      default: 'data.csv',
    },
  },
  computed: {
    ...mapState('weeklyMenu', {
      weekNumber: (state) => state.weekNumber,
      selectedWeek: (state) => state.selectedWeek,
    }),
    ...mapState('global', {
      adminSelectedOffice: 'adminSelectedOffice',
      adminSelectedCompany: 'adminSelectedCompany',
    }),
    orderDates() {
      const weekDates = getWeekStartAndEndDate(this.weekNumber);

      return `
        ${this.$t('orderReport.ordersFor')}
        ${weekDates.startDate.format('MMMM DD')}
        ${this.$t('orderReport.to')}
        ${weekDates.endDate.format('MMMM DD')}
      `;
    },
    isDataToExport() {
      return Object.keys(this.export).length > 0;
    },
  },
  methods: {
    handleExceed() {
      this.$message.warning(this.$t('admin.exceededFileLimitMessage'));
    },
    beforeRemove() {
      return this.$confirm(this.$t('admin.beforeRemoveFileMessage'));
    },
    async loadFile(fileData) {
      const fileReader = new FileReader();
      fileReader.onload = async () => {
        try {
          const fileContent = fileReader.result;
          const jsonArray = await csvtojson({
            output: 'csv',
          }).fromString(fileContent);
          const array = jsonArray.map((e) => {
            return [[e[2]], e[0]];
          });
          this.$emit('load:bamboo', Object.fromEntries(array));
        } catch (errorFromMenuParser) {
          this.$message.error(this.$t(errorFromMenuParser.message));
          this.$emit('load:bamboo', []);
        }
      };
      fileReader.readAsText(fileData.file);
    },
    onDatechange(date) {
      this.$emit('datechanged', date);
    },
    onOfficeChanged(office) {
      this.$emit('officechanged', office);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
.title {
  width: 600px;
  display: flex;
  justify-content: space-between;
  z-index: 500;
}

.buttons-container {
  .button-wrapper {
    display: inline-block;
  }
  .button,
  .hint-message {
    display: block;
  }
  .hint-message {
    font-size: $label-description-text-size;
    text-align: center;
    color: $order-button-hint;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orders/SummaryNavigatorByDate.vue